import React from 'react';
import { colors } from '@styleseat/brand';

type CallCallPhoneIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const CallCallPhoneIcon = ({
  width = 24,
  height = 24,
  color = colors.blackInBlack,
}: CallCallPhoneIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8566 8.33796C11.3747 7.63975 11.5605 6.9039 10.9746 6.25437C9.65961 4.41439 8.77527 3.27655 8.22057 2.7286C7.16601 1.68687 5.43124 1.82778 4.51791 2.72771C4.02736 3.21107 3.86128 3.37706 3.35759 3.88867C0.551938 6.69583 2.26297 12.6301 6.81151 17.1831C11.359 21.7351 17.2927 23.447 20.1042 20.6339C20.569 20.1858 20.9626 19.7921 21.2729 19.464C22.168 18.518 22.3038 16.8598 21.267 15.7825C20.7355 15.2302 19.6504 14.3885 17.7331 13.017C17.1458 12.4919 16.4495 12.6057 15.8112 13.0245C15.5041 13.226 15.2806 13.4297 14.8587 13.8521L14.0924 14.6188C13.9915 14.7198 12.6211 14.0335 11.2908 12.7019C9.95984 11.3696 9.27402 9.99912 9.37447 9.89868L10.1412 9.13148C10.2751 8.99748 10.3391 8.9326 10.4212 8.84633C10.5922 8.6666 10.7338 8.5035 10.8566 8.33796ZM15.5059 16.033L16.2723 15.2662C16.5045 15.0337 16.655 14.8908 16.7774 14.7923C18.4571 15.9985 19.4298 16.7569 19.8272 17.1698C20.0657 17.4176 20.0287 17.8699 19.8213 18.0891C19.5343 18.3924 19.1614 18.7655 18.7039 19.2069C16.8858 21.0257 12.096 19.6437 8.22525 15.7692C4.35327 11.8934 2.97201 7.10285 4.77632 5.29755C5.27798 4.78804 5.43692 4.62918 5.92048 4.15271C6.10178 3.97407 6.59564 3.93395 6.8162 4.15182C7.24326 4.5737 8.03546 5.58805 9.20083 7.21139C9.1405 7.28629 9.06515 7.37093 8.97345 7.4673C8.90615 7.53804 8.85008 7.59488 8.7275 7.71758L7.96148 8.48402C6.65833 9.78706 7.76814 12.0048 9.8771 14.1158C11.9846 16.2254 14.2031 17.3364 15.5059 16.033Z"
      fill={color}
    />
  </svg>
);
